import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getResponsiveImage } from '@/componentWebs/NbmImageNew';
import dynamic from 'next/dynamic';

const OwlCarousel = dynamic(() => import(`@/componentWebs/Global/OwlCarousel`), {
  ssr: false,
  loading: () => null,
});

@connect(({ webs: { dataAd } }) => ({
  dataAd,
}))
class SliderQuangCao extends Component {
  constructor(props) {
    super(props);
    this.state = {
      type: props.type,
      hideNav: null,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize.bind(this), { passive: true });
    this.resize();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.resize.bind(this));
  }

  resize() {
    this.setState({ hideNav: window.innerWidth < 1024 });
  }

  handleClick = item => {
    if (!item.url) return;

    window.location.href = item.url;
  };

  render() {
    const {
      dataAd: { list },
    } = this.props;
    const { type, hideNav } = this.state;
    let positonId = '';

    switch (type) {
      case 'tour': {
        positonId = '50';
        break;
      }

      case 'combo': {
        positonId = '30';
        break;
      }

      case 'hotel': {
        positonId = '29';
        break;
      }

      case 'visa': {
        positonId = '28';
        break;
      }

      default:
        break;
    }

    const newAd =
      (list && list.length > 0 && list.filter(x => x.adsPositionsId === positonId)) || [];

    // console.log('dataAd: ', dataAd);

    const imageResize = [
      {
        desktop: {
          width: 1000
        }
      },
      {
        tablet: {
          width: 400
        }
      },
      {
        mobile: {
          width: 300
        }
      }
    ]
    return (
      <>
        {newAd && newAd.length > 0 && (
          <div className={hideNav ? 'container-normal' : ''}>
            <div className="adSlider adSlider-quang-cao">
              <OwlCarousel
                //   className="section-khachHang-owlCarousel"
                // items={1}
                // margin={1}
                responsive={{
                  0: {
                    nav: false,
                    items: 1,
                    margin: 14,
                    dots: true,
                  },
                  425: {
                    nav: false,
                    items: 1,
                    margin: 14,
                    dots: true,
                  },
                  768: {
                    nav: true,
                    items: 1,
                    margin: 1,
                    dots: false,
                  },
                  1000: {
                    nav: true,
                    items: 1,
                    margin: 1,
                    dots: false,
                  },
                }}
                // slideBy={1}
                nav
                navText={[
                  '<img src="/static/vietnamTickets/images/Icon ionic-ios-arrow-forward (1).svg" />',
                  '<img src="/static/vietnamTickets/images/Icon ionic-ios-arrow-forward-1.svg" />',
                ]}
                // navText={[
                //   '<i className="fas fa-angle-left"></i>',
                //   '<i className="fas fa-angle-right"></i>',
                // ]}
                navElement="div"
                center
                loop
              // autoplay
              >
                {newAd.map(item => (
                  <div
                    className="adSlider__img"
                    key={item.id}
                    onClick={() => this.handleClick(item)}
                  >
                    <img
                      src={getResponsiveImage(
                        item.contents && item.contents[0] && item.contents[0].file
                        , imageResize)}
                      className="lazyload"
                      alt={item.title}
                    />
                  </div>
                ))}
              </OwlCarousel>
            </div>
          </div>
        )}
      </>
    );
  }
}

export default SliderQuangCao;
